import { ClassificationType } from "@evergis/api";

export const RANGE_MIN = 2;

export const RANGE_DEFAULT = 7;

export const RANGE_MAX = 20;

export const MIN_OBJECTS_COUNT = 8;

export const MAX_OBJECTS_COUNT = 2000;

export const ALL_UNIQUE_CLASSES_LIMIT = 100;

export const ALGORITHM_CLASS_COUNT = {
  [ClassificationType.Quantile]: 7,
  [ClassificationType.EqualInterval]: 7,
  [ClassificationType.NaturalBreaks]: 5,
  [ClassificationType.Unique]: 10,
};

export const CLASSES_RANGE_CALC_DEFAULTS = {
  maxWidth: "31.875rem",
};
